/* eslint-disable */
import React, { Component } from 'react'; 
import { withRouter } from "react-router-dom"
import * as wording from '../js/wording.js';
import Button from '../UiComponent/Button';
import HTMLText from '../UiComponent/HTMLText';
import  './FormPage.scss'
import RaceInfoTable from './RaceInfoTable'
import RaceFormTable from './RaceFormTable'
import * as util from '../js/util.js'
import * as api from '../js/api.js'
import Image from '../UiComponent/Image'
import FormConfirmationBox from './FormConfirmationBox.js';
import { isUndefined } from 'util';
class FormPage extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			fMsg:'',
			raceInfo:{},			
			showError:false,
			errorMsg:'',
			personalInfo:{},
			showConfirmPrompt:false,
			ready:false,
			apiReady:false
		};
		
		if (window.urlParams && window.urlParams.eventId){
			window.info.eventId = window.urlParams.eventId;
			util.saveSession('F');	
		}	
		if (window.urlParams && window.urlParams.t){
			window.info.t = window.urlParams.t;
			util.saveSession('F');	
		}	
		this.isProcessing = false;
		this.showError = this.showError.bind(this);		
		this.closeError = this.closeError.bind(this);		
		this.showConfirmPage = this.showConfirmPage.bind(this);
		this.onConfirmClicked = this.onConfirmClicked.bind(this);
		this.onCloseConfirmClicked = this.onCloseConfirmClicked.bind(this);
		this.getRaceEventInfo = this.getRaceEventInfo.bind(this);
		this.submitApplication = this.submitApplication.bind(this);
		wording.getWording('/wording/FormPage.json').then((wordingJson) => this.setState({fMsg : wordingJson,ready:true}));
	}

	componentDidMount() {	
		this.props.rootHideShowLoading('show');
		this.getRaceEventInfo(window.info.eventId,this.props.history,function(data,_this, history){		
			if (!data || data.success=='N'){	
				_this.props.rootHideShowLoading('hide');	
				history.push(window.info.config.pathname +"/404.html");	
				return;
			}
			_this.props.rootHideShowLoading('hide');	
			_this.setState({raceInfo:data.result,apiReady:true});
		})
	}

	componentWillUnmount() {
	}


	getRaceEventInfo(id,history,callback ){
		
        if (!id){
            id = '';
		}
		var data = new FormData();
		data.append('eventId',id);
		data.append('t',window.info.t ? window.info.t:'N');
        var apiInfo ={
			api: window.info.config.filepathname+ '/php/api/getEventInfo.php',
			params : data			
        };

        api.post(this, apiInfo,function(data, _this){			
			var returnJson = data || null;			
			
			callback(returnJson, _this, history);
			return;
		});        
	}

	submitApplication(info,history,callback ){
		var data = new FormData();
		if (!info.chineseName){
			info.chineseName = '';
		}
		if (!info.mobile){
			info.mobile = '';
		}

		if (!info.guardianName){
			info.guardianName = '';
		}

		if (!info.guardianMobile){
			info.guardianMobile = '';
		}

		if (!info.id){
			info.id = '';
		}
		data.append('chiName',info.chineseName);
		data.append('engName', info.englishName);
		data.append('dob', info.dobYear + '-' + info.dobMonth + '-' + info.dobDay);
		data.append('idNumber', info.id);
		data.append('email', info.email);
		data.append('mobile', info.mobile);
		data.append('gender', info.gender);
		data.append('gName', info.guardianName);
		data.append('gMobile',info.guardianMobile);
		data.append('race', info.selectedList);
		data.append('optField', info.optField?info.optField:"");
        var apiInfo ={
			api: window.info.config.filepathname+ '/php/api/submitApplication.php',
			params : data
        };

        api.post(this, apiInfo,function(data, _this){			
			var returnJson = data || null;			
			callback(returnJson, _this, history);
			return;
		});        
	}

	
	showError(msg){
		this.setState({errorMsg:msg,showError:true});
	}

	closeError(){
		this.setState({errorMsg:'',showError:false});
	}
	showConfirmPage(info){
		this.setState({personalInfo:info,showConfirmPrompt:true});
	}
	onConfirmClicked(){
		this.props.rootHideShowLoading('show');	
		if (this.isProcessing){
			return;
		}else{
			this.isProcessing = true;
		}
		
		this.submitApplication(this.state.personalInfo,this.props.history,function(data,_this, history){
			if (!data || data.success=='N'){	
				_this.props.rootHideShowLoading('hide');
				_this.showError(_this.state.fMsg.submitFailZh+"<br/>"+_this.state.fMsg.submitFailEn);
				_this.isProcessing = false;
				return;
			}else{				
				window.info.orderNumber = data.orderId;
				util.saveSession('F');	
				_this.setState({personalInfo:{},showConfirmPrompt:false});
				_this.props.rootHideShowLoading('hide');	
				history.push(window.info.config.pathname +"/success.html");	
			}		
		});
	}

	onCloseConfirmClicked(){
		this.setState({personalInfo:{},showConfirmPrompt:false});
	}

	render() {		
		return (
            <div id="FormPage">		
			{this.state.ready && this.state.apiReady && (		
				<div className='form-title'>
					
					<div className='form-title-image-overlay'></div>
					<HTMLText className='title-desc' text={this.state.fMsg.formTitleZh +"<br/>" + this.state.fMsg.formTitleEn}/>
				</div>
			)}
				{this.state.showError && (
					<React.Fragment>
						<div className='prompt-overlay'></div>
						<div className='error-prompt'>
							<div className='error-message'>
								<HTMLText text={this.state.errorMsg} className='f1-font'/>
							</div>
							<div className='popup-button-div'>
								<Button text={this.state.fMsg.closeZh +"<br/>" + this.state.fMsg.closeEn} 
								className='defaultButton popup-button' onClickAction={this.closeError}/>
							</div>
						</div>
					</React.Fragment>
					)}
				{this.state.ready && this.state.apiReady && (
					<div className='content'>
						<RaceInfoTable raceInfo={this.state.raceInfo} labelText={this.state.fMsg} eventId={window.info.eventId} />
						<RaceFormTable raceInfo={this.state.raceInfo} showError={this.showError} labelText={this.state.fMsg} eventId={window.info.eventId} onFormSubmitClicked={this.showConfirmPage} />
					</div>
				)}
				{this.state.showConfirmPrompt &&(
					<div className='prompt-overlay-form'>
						
						<FormConfirmationBox onCloseConfirmClicked={this.onCloseConfirmClicked} onConfirmClicked={this.onConfirmClicked} raceInfo={this.state.raceInfo} personalInfo={this.state.personalInfo} labelText={this.state.fMsg}/>
						
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(FormPage);